import { HierarchyDto } from './../../service/dto';
import { Component, OnDestroy, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { HierarchyService } from '../../service/hierarchy.service';
import { Subscription } from 'rxjs';
import { NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/tree';

// class Wrapper{
// 	payload!: HierarchyDto;
// 	children!: Wrapper[];

// 	get title(): string{
// 		return this.payload.name;
// 	}
// 	get key(): number{
// 		return this.payload.id;
// 	}
// }
@Component({
	selector: 'app-hierarchy-input',
	standalone: false,
	templateUrl: './hierarchy-input.component.html',
	styleUrl: './hierarchy-input.component.scss'
})
export class HierarchyInputComponent implements OnInit, OnDestroy {
	@Input() hierarchy?: HierarchyDto;
	@Output() onChange = new EventEmitter<HierarchyDto>();

	selectedId?: string;
	expandedKeys: string[] = [];
	nodes: NzTreeNodeOptions[] = [];
	subscription = new Subscription();
	constructor(private service: HierarchyService) { }
	ngOnInit(): void {
		if (!this.hierarchy) {
			this.hierarchy = this.service.hierarchy;
		}
		this.nodes = [this.toNode(this.service.fullHierarchy!)];
		this.selectedId = '' + (this.hierarchy?.id ?? this.service.hierarchy!.id);
		this.expandedKeys = this.service.findHierarchyAndParents(+this.selectedId).map(item => "" + item.id);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	change(selectedId: string) {
		// this.service.setHierarchyById(+selectedId);
		this.onChange.emit(this.service.findHierarchyById(+this.selectedId!, this.service.fullHierarchy!));
	}


	private toNode(input: HierarchyDto): NzTreeNodeOptions {
		return {
			title: input.name,
			key: '' + input.id,
			isLeaf: input.subHierarchies.length == 0,
			children: input.subHierarchies.map(item => this.toNode(item))
		};
	}

}
